<template>
  <div class="table-wrapper">
    <el-table
      :data="data"
      stripe
      style="width: 100%"
      size="medium"
      header-row-class-name="common-table-header"
      row-class-name="common-table-row"
      class="is-print-hide common-table"
      :border="false"
    >
      <el-table-column prop="medicalInsuranceCode" label="医保药品代码">
        <template #default="{ row: { medicalInsuranceCode } }">
          <el-tooltip :content="medicalInsuranceCode" placement="top" effect="light" :disabled="!medicalInsuranceCode">
            <span class="medical-insurance-code">
              {{ medicalInsuranceCode }}
            </span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="barcode" label="药品条形码">
        <template #default="{ row: { barcode } }">
          <el-tooltip :content="barcode" placement="top" effect="light" :disabled="!barcode">
            <span class="medical-insurance-code">{{ barcode }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="drugName" label="药品通用名" width="180">
        <template #default="{ row: { drugName } }">
          <el-tooltip :content="drugName" placement="top" effect="light" :disabled="!drugName">
            <span class="medical-insurance-code">{{ drugName }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="spec" label="药品规格">
        <template #default="{ row: { spec } }">
          <el-tooltip :content="spec" placement="top" effect="light" :disabled="!spec">
            <span class="medical-insurance-code">{{ spec }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="drugEnterprise" label="生产厂家">
        <template #default="{ row: { drugEnterprise } }">
          <el-tooltip :content="drugEnterprise" placement="top" effect="light" :disabled="!drugEnterprise">
            <span class="medical-insurance-code">{{ drugEnterprise }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="approvalNumber" label="批准文号">
        <template #default="{ row: { approvalNumber } }">
          <el-tooltip :content="approvalNumber" placement="top" effect="light" :disabled="!approvalNumber">
            <span class="medical-insurance-code">{{ approvalNumber }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="unit" label="包装单位">
        <template #default="{ row: { unit } }">
          <el-tooltip :content="unit" placement="top" effect="light" :disabled="!unit">
            <span class="medical-insurance-code">{{ unit }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="drugUsage" label="用法">
        <template #default="{ row: { drugUsage } }">
          <el-tooltip :content="drugUsage" placement="top" effect="light" :disabled="!drugUsage">
            <span class="medical-insurance-code">{{ drugUsage }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="drugStatus" label="状态">
        <template #default="{ row: { drugStatus } }">
          <el-tooltip
            :content="$options.filters.adaptDrugStatus(drugStatus)"
            placement="top"
            effect="light"
            :disabled="!drugStatus && drugStatus !== 0"
          >
            <span :class="{ 'status-active': drugStatus === 0, 'status-inactive': drugStatus === 1 }">
              {{ drugStatus | adaptDrugStatus }}
            </span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="modifiedTime" label="更新时间">
        <template #default="{ row: { modifiedTime } }">
          <el-tooltip :content="modifiedTime" placement="top" effect="light" :disabled="!modifiedTime">
            <span class="medical-insurance-code">{{ modifiedTime }}</span>
          </el-tooltip>
        </template>
      </el-table-column>

      <el-table-column label="操作">
        <template #default="{ row }">
          <span class="btn" @click="goViewDrug(row)">查看</span>
          <span class="btn" @click="goEditDrug(row)">编辑</span>
          <span class="btn" @click="deleteDrug(row)">删除</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-wrapper">
      <el-pagination
        class="is-print-hide common-el-pagination"
        layout="prev, pager, next, total, jumper, sizes"
        :total="total"
        :current-page="pageNo"
        :page-sizes="pageSizes"
        :page-size="pageSize"
        @current-change="val => $emit('handle-pageNo', val)"
        @size-change="val => $emit('handle-pageSize', val)"
      />
      <div class="sureJump global_common_button_goast">确定</div>
    </div>
  </div>
</template>

<script>
import Fetch from '@/api';

export default {
  name: 'drugsManagement',
  props: {
    data: {
      type: Array
    },
    total: {
      type: Number
    },
    pageNo: {
      type: Number
    },
    pageSize: {
      type: Number,
      default: 10
    },
    pageSizes: {
      type: Array
    }
  },
  filters: {
    adaptDrugStatus(val) {
      const statusMap = { 0: '生效中', 1: '已失效' };
      return statusMap[val] || '';
    }
  },
  methods: {
    deleteDrug(row) {
      this.$confirm('删除药品，将把该药品从药店药品库移除', '确认删除药品', {
        confirmButtonText: '我再想想',
        cancelButtonText: '删除',
        customClass: 'confirm',
        distinguishCancelAndClose: true,
        center: true
      })
        .then(() => {})
        .catch(type => {
          if (type === 'cancel') {
            Fetch.deleteMedicalDrugsByMedicalInsuranceCode({ medicalInsuranceCodes: [row.medicalInsuranceCode] }).then(
              () => this.$emit('refresh')
            );
          }
        });
    },
    goEditDrug(row) {
      this.$router.push({
        path: `/drugsManagement/clinic/edit`,
        query: { medicalInsuranceCode: row.medicalInsuranceCode }
      });
    },
    goViewDrug(row) {
      this.$router.push({
        path: `/drugsManagement/clinic/view`,
        query: { medicalInsuranceCode: row.medicalInsuranceCode }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.btn {
  color: #1e8dff;
  font-size: 12px;
  cursor: pointer;

  & + .btn {
    margin-left: 5px;
  }
}

.medical-insurance-code {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: default;
}

.status-active {
  color: #67c23a;
  font-weight: 500;
}

.status-inactive {
  color: #f56c6c;
  font-weight: 500;
}

.pagination-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 22px;

  /deep/.el-pagination {
    margin-top: 0;
  }

  .sureJump {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    margin-left: 10px;
    width: 80px;
    height: 32px;
    border-radius: 3px;
    cursor: pointer;
  }
}
</style>
